import { inject, Injectable } from '@angular/core';
import { AuthService } from '@libs/shared/auth';
import { TargetType } from '@libs/shared/models';
import { ProductBaseModel } from '@libs/shop/models';
import { firstValueFrom } from 'rxjs';
import { AppLinkRouterService } from './app-link-router.service';
import { LinkRouter } from './link-router.model';

@Injectable({ providedIn: 'root' })
export class LinkRouterService implements LinkRouter {
  private readonly router: LinkRouter = inject(AppLinkRouterService);
  private readonly authService: AuthService = inject(AuthService);

  public async formatHref(url: string): Promise<string> {
    return this.router.formatHref(url);
  }

  public getProductRawHref(product: ProductBaseModel): string {
    return this.router.getProductRawHref(product);
  }

  public navigate(href: string, target?: TargetType): void {
    // special link 'sso-login'
    if (href.startsWith('/sso-login')) {
      void firstValueFrom(this.authService.login());

      return;
    }

    this.router.navigate(href, target);
  }
}
